import React, { FC, useCallback } from 'react';
import { Link } from 'react-router-dom';
import classes from '../../asset/css/shipping-address-form/form.module.css';
import { ShippingAddressViewType } from '../../types/view/shipping-address-view-type';

export const Form: FC<{
  shippingAddress?: ShippingAddressViewType;
  changeFunc: (key: string, value: string) => void;
  submitFunc: () => void;
}> = ({ shippingAddress, changeFunc, submitFunc }) => {
  let prefecturesHtml: JSX.Element[] = [];
  if (shippingAddress) {
    prefecturesHtml = shippingAddress.country.zones.map((zone, idx) => {
      return (
        <option value={zone.code} key={idx}>
          {zone.name}
        </option>
      );
    });
  }

  let countriesHtml: JSX.Element[] = [];
  if (shippingAddress) {
    countriesHtml = shippingAddress.countries.map((country, idx) => {
      return (
        <option value={country.code} key={idx}>
          {country.name}
        </option>
      );
    });
  }

  const changeEventHandler = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      changeFunc(event.target.name, event.target.value);
    },
    [changeFunc]
  );

  const selectEventHandler = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      changeFunc(event.target.name, event.target.value);
    },
    [changeFunc]
  );

  const btnClickEventHandler = useCallback(() => {
    submitFunc();
  }, [submitFunc]);

  return (
    <>
      <form className={classes.mypage_subsc_edit_form}>
        <h2>お届け先の変更</h2>
        <div>
          <div>姓</div>
          <div>
            <input
              type="text"
              placeholder="姓"
              name="lastName"
              value={shippingAddress ? shippingAddress.lastName : ''}
              onChange={changeEventHandler}
            />
          </div>
        </div>
        <div>
          <div>名</div>
          <div>
            <input
              type="text"
              placeholder="名"
              name="firstName"
              value={shippingAddress ? shippingAddress.firstName : ''}
              onChange={changeEventHandler}
            />
          </div>
        </div>
        <div>
          <div>郵便番号</div>
          <div>
            <input
              type="text"
              placeholder="郵便番号"
              name="zip"
              value={shippingAddress ? shippingAddress.zip : ''}
              onChange={changeEventHandler}
            />
          </div>
        </div>
        <div style={{display:"none"}}>
          <div>会社名</div>
          <div>
            <input
              type="text"
              placeholder="会社名"
              name="company"
              value={shippingAddress ? shippingAddress.company : ''}
              onChange={changeEventHandler}
            />
          </div>
        </div>
        <div>
          <div>国/地域</div>
          <div>
            <select name="countryCode" value={shippingAddress ? shippingAddress.countryCode : ''} onChange={selectEventHandler}>
              {countriesHtml}
            </select>
          </div>
        </div>
        <div>
          <div>都道府県</div>
          <div>
            <select name="provinceCode" value={shippingAddress ? shippingAddress.provinceCode : ''} onChange={selectEventHandler}>
              {prefecturesHtml}
            </select>
          </div>
        </div>
        <div>
          <div>市区町村</div>
          <div>
            <input
              type="text"
              placeholder="市区町村"
              name="city"
              value={shippingAddress ? shippingAddress.city : ''}
              onChange={changeEventHandler}
            />
          </div>
        </div>
        <div>
          <div>住所</div>
          <div>
            <input
              type="text"
              placeholder="住所"
              name="address1"
              value={shippingAddress ? shippingAddress.address1 : ''}
              onChange={changeEventHandler}
            />
          </div>
        </div>
        <div>
          <div>建物名、部屋番号など</div>
          <div>
            <input
              type="text"
              placeholder="建物名、部屋番号など"
              name="address2"
              value={shippingAddress ? shippingAddress.address2 : ''}
              onChange={changeEventHandler}
            />
          </div>
        </div>
        <div>
          <div>電話番号</div>
          <div>
            <input
              type="tel"
              placeholder="電話番号"
              name="phone"
              value={shippingAddress ? shippingAddress.phone : ''}
              onChange={changeEventHandler}
            />
          </div>
        </div>
        <div className={classes.mypage_subsc_address_submit}>
          <button type="button" onClick={btnClickEventHandler}>
            変更する
          </button>
          <Link to="/">もどる</Link>
        </div>
      </form>
    </>
  );
};
